import React from 'react';
import { Link } from 'react-router-dom';

const Card = ({ path, title, children }: { path: string; title: string; children: React.ReactNode }) =>
  <Link className="project-card" to={path}><h2>{title}</h2><p>{children}</p></Link>;

export function ToolsPage({ admin }: { admin: boolean }) {
  return <section className="project-page"><h1>Tools</h1>
    <p>Supporting information, account administration and historical pages.</p>
    <div className="project-cards">
      <Card path="/strategy/inspection" title="Model inspection">Inspect the inputs and explanations behind model outputs.</Card>
      <Card path="/betfair" title="Account connection">Manage the existing Betfair account connection.</Card>
      <Card path="/tools/archive" title="Archive">Find historical information from retired pages.</Card>
      {admin && <>
        <Card path="/all-notes" title="Voice notes">Find notes attached to races, horses and meetings.</Card>
        <Card path="/review" title="Review queue">Review captured information before accepting it.</Card>
        <Card path="/settings" title="Settings">Existing project settings.</Card>
        <Card path="/users" title="Users">Manage accounts and access.</Card>
        <Card path="/strategy/typec-research" title="Type C Research">Lay research: baseline vs challengers, tracks, price bands, multi-lays, forward paper.</Card>
      </>}
    </div>
  </section>;
}
export function ReportsPage() {
  return <section className="project-page"><h1>Reports</h1>
    <p>Choose the records you want to review. These views cover different sources and can overlap; their totals should not be added together.</p>
    <div className="project-cards">
      <Card path="/strategy/bucket-bets" title="Bucket history">Selections and results grouped by bucket, including the combined time-sorted view.</Card>
      <Card path="/strategy/brain" title="Brain paper results">Recorded paper results, stream evidence and research views.</Card>
      <Card path="/strategy/results" title="Strategy history">The existing report of strategy runs, with its own paper and live classifications.</Card>
      <Card path="/my-bets" title="Account history">Orders and results from the connected account.</Card>
      <Card path="/reports/jockeys" title="Jockey performance">Win strike rates, Betfair BSP ROI and each jockey’s best track from June 2026.</Card>
      <Card path="/results/day" title="Race results">Official race outcomes by meeting and day.</Card>
    </div>
  </section>;
}
export function ArchivePage() {
  return <section className="project-page"><h1>Retired pages</h1>
    <p>The old Parlay, Place, Lanes, Graduation &amp; Culling, Turnover-Cover staking and Engines pages have been retired from this interface. Historical records have been retained.</p>
    <div className="project-cards">
      <Card path="/tools/flow-history" title="Flow history">Read the existing Flow ledger without its former execution controls.</Card>
      <Card path="/strategy/results" title="Strategy history">Review historical strategy records, including existing engine breakdowns.</Card>
      <Card path="/strategy/bucket-bets" title="Bet Buckets">The current bucket page replaces the old Buckets destination.</Card>
    </div>
    <p>Removing a page does not delete its database records or change background services.</p>
  </section>;
}
export function NotFoundPage() {
  return <section className="project-page"><h1>Page not found</h1>
    <p>This address is not recognised. <Link to="/">Return to Racing</Link> or <Link to="/tools">browse Tools</Link>.</p>
  </section>;
}
